import Vue from "vue";
import Vuex from "vuex";
import commons from './modules/commons'
import transactions from './modules/transactions'
import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    commons,
    transactions
  },
  state: {},
  mutations: {},
  actions: {},
  strict: false,
  plugins: [createPersistedState({paths:['commons'], storage: window.localStorage})]
});
